import React, {Component} from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';

class MobileSelector extends Component {
  render() {
    let rows = [];
    for(let i = 0; i < this.props.maxIdx - 1; i++) {
      let active = false;

      if(i + 1 >= this.props.activeIdx && i + 1 <= this.props.howManyToShow + (this.props.activeIdx - 1)) active = true;

      rows.push(
        <Grid 
          key={i}
          xs={2}
          className={active ? 'active' : ''}
          item>
          <Button 
            color={active ? 'default' : 'primary'}
            variant={active ? 'outlined' : 'contained'}
            onClick={this.props.selectIdx.bind(this, i + 1)}>
            {i === 0 ? 'All' : 'E' + (i)}
          </Button>
        </Grid>
      )
    }
    return(
      <div>
        {this.props.howManyToShow === 1 &&
          <Grid
            className="mobile-footer-buttons pa2"
            justify="space-around"
            container>
            {rows}
          </Grid>
        }
      </div>
    )
  }
}

MobileSelector.propTypes = {
  activeIdx: PropTypes.number.isRequired,
  maxIdx: PropTypes.number.isRequired,
  howManyToShow: PropTypes.number.isRequired,
  selectIdx: PropTypes.func.isRequired
}

export default MobileSelector;